import { useSelector } from 'react-redux';
import { getFlag } from 'state/Flags';
import { expectedFlags } from 'feature-flags';
import { RosteredShift } from 'type';

/**
 * Hook to get the pay rate for a rostered shift from the API response
 * The pay rate comes from /api/rostered-shifts endpoint as pay_rate.rate
 * Only returns a pay rate if the multiplePayRates feature flag is enabled
 */
export function useShiftPayRate(rosteredShift: RosteredShift | null | undefined): string | null {
  // All hooks must be called unconditionally at the top
  const multiplePayRatesEnabled = useSelector(getFlag[expectedFlags.multiplePayRates]);
  
  // Early returns after all hooks have been called
  // Pay rate should only be displayed if the feature flag is enabled
  if (!multiplePayRatesEnabled) {
    return null;
  }

  if (!rosteredShift) {
    return null;
  }

  // Get pay rate directly from the rostered shift's pay_rate property
  const payRate = rosteredShift.pay_rate;
  
  if (payRate != null && !isNaN(payRate)) {
    return `£${payRate.toFixed(2)} p/h`;
  }

  return null;
}

